import { NavLink } from 'react-router-dom';


const CheckoutNavbar = () => {
     return (
          <>
               <div className='row' style={{ margin: '0' }}>
                    <div className='col-12 searchTypeRow'>
                         <div className='topnav'>
                              <NavLink to={`/checkout/request`}>درخواست های واریز</NavLink>
                              <NavLink to={`/checkout/setting`}>تنظیمات</NavLink>
                         </div>
                    </div>
               </div>
          </>
     )
}

export default CheckoutNavbar